// @flow
import { DEFAULT_LANG } from '@rover/shared/js/constants/i18n/language';
import I18N_FORMAT_MAP from '@rover/design-system/style-dictionary/build/es6/i18nFormatMap.constants';

const getLocalizedFormatContextless = (format: string, lang: ?string): string => {
  const langs = I18N_FORMAT_MAP[(lang || '').toLowerCase()] || I18N_FORMAT_MAP[DEFAULT_LANG];
  return langs[format] || I18N_FORMAT_MAP[DEFAULT_LANG][format] || format;
};

export default getLocalizedFormatContextless;



// WEBPACK FOOTER //
// ../shared/js/constants/i18n/datetime/getLocalizedFormatContextless.js